export default "__VITE_ASSET__9bde1239__"